package com.gastoncantera.intercom.ui

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import kotlinx.coroutines.delay
import kotlinx.coroutines.isActive

// Declaraciones mínimas de Web Audio para generar el tono sin recursos binarios.
private external class AudioContext {
    val destination: AudioNode
    fun createOscillator(): OscillatorNode
    fun createGain(): GainNode
    fun resume()
    fun close()
}

private external interface AudioNode {
    fun connect(destination: AudioNode)
}

private external interface AudioParam {
    var value: Double
}

private external interface OscillatorNode : AudioNode {
    var type: String
    val frequency: AudioParam
    fun start()
    fun stop()
}

private external interface GainNode : AudioNode {
    val gain: AudioParam
}

/** Genera un tono de llamada con cadencia de teléfono (dos pulsos + pausa) en loop. */
@Composable
actual fun Ringtone(playing: Boolean) {
    LaunchedEffect(playing) {
        if (!playing) return@LaunchedEffect
        val ctx = AudioContext()
        ctx.resume()
        val osc = ctx.createOscillator()
        val gain = ctx.createGain()
        osc.type = "sine"
        osc.frequency.value = 440.0
        gain.gain.value = 0.0
        osc.connect(gain)
        gain.connect(ctx.destination)
        osc.start()
        try {
            while (isActive) {
                repeat(2) {
                    gain.gain.value = 0.18
                    delay(400)
                    gain.gain.value = 0.0
                    delay(200)
                }
                delay(1800)
            }
        } finally {
            runCatching { osc.stop() }
            runCatching { ctx.close() }
        }
    }
}
